<template>
    <section>
        <div id="date-section" class="d-flex justify-content-center filter-section">
            <div id="dashboard-date-filter" class="d-flex justify-content-center">
                <div class="filter-group">
                    <label for="">De</label>
                    <input type="date" class="form-control" v-model="startDate">
                </div>
                <div class="filter-group">
                    <label for="">Até</label>
                    <input type="date" class="form-control" v-model="endDate">
                </div>
                <div id="period-filter" class="filter-group">
                    <label for="">Período</label>
                    <select name="period" id="period" class="form-control" v-model="period">
                        <option value="month">Mês</option>
                        <option value="week">Semana</option>
                        <option value="day">Dia</option>
                        <option value="hour">Hora</option>
                    </select>
                </div>
                <button type="button" id="generate-button" class="btn btn-primary mb-0 form-control" @click="generate"><i class="fas fa-chart-pie"></i> <span>Gerar dashboard!</span></button>
            </div>
        </div>
        <div id="dynamic-section"
            :class="['justify-content-center filter-section',{'custom-slide': dynamic}]"
        >
            <div class="col" id="dynamic-filters">
                <div class="d-flex">
                    <div id="channel-filter" class="filter-group">
                        <label for="channel">Canal de atendimento</label>
                        <multiselect 
                            class="multi-select"
                            v-model="selected.channel" 
                            :options="options.channel" 
                            :multiple="true" 
                            track-by="value" 
                            label="label" 
                            placeholder="Selecione..." 
                            :close-on-select="false"
                            :select-label="'Clique para selecionar'"
                            :deselect-label="'Clique para remover'"
                            :selected-label="'Selecionado'"
                            :open-direction="'bottom'"
                        ></multiselect>
                    </div>
                    <div id="subject-filter" class="filter-group">
                        <label for="">Assunto</label>
                        <multiselect 
                            class="multi-select"
                            v-model="selected.subject" 
                            :options="options.subject" 
                            :multiple="true" 
                            track-by="value" 
                            label="label" 
                            placeholder="Selecione..." 
                            :close-on-select="false"
                            :select-label="'Clique para selecionar'"
                            :deselect-label="'Clique para remover'"
                            :selected-label="'Selecionado'"
                            :open-direction="'bottom'"
                        ></multiselect>
                    </div>
                    <div id="motivation-filter" class="filter-group">
                        <label for="">Motivo</label>
                        <multiselect 
                            class="multi-select"
                            v-model="selected.reason" 
                            :options="options.motivation" 
                            :multiple="true" 
                            track-by="value" 
                            label="label" 
                            placeholder="Selecione..." 
                            :close-on-select="false"
                            :select-label="'Clique para selecionar'"
                            :deselect-label="'Clique para remover'"
                            :selected-label="'Selecionado'"
                            :open-direction="'bottom'"
                        ></multiselect>
                    </div>
                </div>
                <div class="d-flex">
                    <div id="bank-filter" class="filter-group">
                        <label for="">Instituição Financeira</label>
                        <multiselect 
                            class="multi-select"
                            v-model="selected.instituicao_financeira" 
                            :options="options.bank" 
                            :multiple="true" 
                            track-by="value" 
                            label="label" 
                            placeholder="Selecione..." 
                            :close-on-select="false"
                            :select-label="'Clique para selecionar'"
                            :deselect-label="'Clique para remover'"
                            :selected-label="'Selecionado'"
                            :open-direction="'bottom'"
                        ></multiselect>
                    </div>
                    <div id="chat-queue-filter" class="filter-group">
                        <label for="">Filas de Chat</label>
                        <multiselect 
                            class="multi-select"
                            v-model="selected.chatQueue" 
                            :options="options.chatQueue" 
                            :multiple="true" 
                            track-by="value" 
                            label="label" 
                            placeholder="Selecione..." 
                            :close-on-select="false"
                            :select-label="'Clique para selecionar'"
                            :deselect-label="'Clique para remover'"
                            :selected-label="'Selecionado'"
                            :open-direction="'bottom'"
                        ></multiselect>
                    </div>
                    <div id="bank-filter" class="filter-group">
                        <label for="">Filas de Telefonia</label>
                        <multiselect 
                            class="multi-select"
                            v-model="selected.queue" 
                            :options="options.queue" 
                            :multiple="true" 
                            track-by="value" 
                            label="label" 
                            placeholder="Selecione..." 
                            :close-on-select="false"
                            :select-label="'Clique para selecionar'"
                            :deselect-label="'Clique para remover'"
                            :selected-label="'Selecionado'"
                            :open-direction="'bottom'"
                        ></multiselect>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import Multiselect from 'vue-multiselect'   
    export default {
        props: ['dynamic', 'filters', 'reset'],
        components: {
            Multiselect
        },
        data(){
            return {
                startDate: '',
                endDate: '',
                period: 'month',
                selected: {
                    channel: '',
                    subject: '*',
                    reason: '*',
                    instituicao_financeira: '*',
                    chatQueue: '*',
                    queue: '*',
                },
                options: {
                    channel: this.filters.channels,
                    subject: this.filters.subjects,
                    motivation: this.filters.motivations,
                    bank: this.filters.banks,
                    chatQueue: this.filters.chatQueues,
                    queue: this.filters.phoneQueues,
                }
            }
        },
        methods: {
            async generate(){
                this.$emit('generateDashboard', {params: {start: this.startDate, end: this.endDate, period: this.period}, period: this.period})
            },
            resetDate(){
                const dateNow = moment();

                const firstDay = dateNow.startOf('month').format('YYYY-MM-DD');
                this.startDate = firstDay;

                const lastDay = dateNow.endOf('month').format('YYYY-MM-DD');
                this.endDate = lastDay;

                this.period = 'month';
            }
        },
        mounted() {
            this.resetDate();
            this.selected.channel = this.options.channel;
            this.selected.subject = this.options.subject;
            this.selected.reason = this.options.motivation;
            this.selected.instituicao_financeira = this.options.bank;
            this.selected.chatQueue = this.options.chatQueue;
            this.selected.queue = this.options.queue;

        },
        watch: {
            reset(){
                console.log('resetando');
                this.resetDate()
            },
            filters: {
                deep: true,
                handler(newVal){
                    this.options.channel = this.filters.channels
                    this.selected.channel = this.filters.channels
                    this.options.subject = this.filters.subjects
                    this.selected.subject = this.filters.subjects
                    this.options.motivation = this.filters.motivations
                    this.selected.reason = this.filters.motivations
                    this.options.bank = this.filters.banks
                    this.selected.instituicao_financeira = this.filters.banks
                    this.options.chatQueue = this.filters.chatQueues
                    this.selected.chatQueue = this.filters.chatQueues
                    this.options.queue = this.filters.phoneQueues
                    this.selected.queue = this.filters.phoneQueues
                    
                }
            },
            selected: {
                deep: true,
                handler(newVal){
                    let newFilters = {}
                    Object.entries(newVal).forEach(el => {
                        newFilters[el[0]] = [];
                        el[1].forEach(values => {
                            newFilters[el[0]].push(values.value)
                        })
                    })
                    this.$emit('changeFilters', {filters: newFilters})
                }
            }
        }
    }
</script>

<style>

.filter-section{
    flex: 1;
    padding: 3px;
    transition: ease-in 0.5s;
}

#date-section{
    border-bottom: 1px solid #1c869a;
    background-color: #679ea9;
    z-index: 2;
    max-height: 80px;
}

#dynamic-section{
    border-top: 1px solid #1c869a;
    background-color: #679ea9;
    z-index: 0;
    position: relative;
    top: -300;
    transition: 0.5s;
}

#dynamic-filters{
    width: 100%;
    /* overflow-x: auto; */
    /* overflow-x: auto; */
    transition: all;
}

#dashboard-date-filter{
    align-items: flex-end;
    height: 60px;
}

#generate-button{
    margin-left: 10px;
    border: 2px solid #1c869a;
    border-radius: 5px !important;
    background-color: white;
    color: #1c869a !important;
    width: 200px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 2px !important;
}

#generate-button:hover{
    color: white !important;
    background-color: #2e5a63;
    transition: 0.3s;
    border: 2px solid white;
}

#generate-button span{
    font-weight: bold;
    margin-left: 8px;
}

#generate-button i{
    font-size: large;
}

.multi-select .multiselect__tags{
    max-height: 65px !important;
    overflow-x: auto;
}

.multi-select .multiselect__tag{
    font-size: smaller;
    background-color: #1c869a;
}

.multi-select .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
    background: #126c7c;
}

.multi-select .multiselect__element{
    padding: 1px;
}

.multi-select .multiselect__element span{
    font-size: smaller;
}

.multi-select  .multiselect__option--selected.multiselect__option--highlight {
  font-size: smaller; /* Tamanho da fonte desejado */
}

#dynamic-message{
    font-size: large;
    font-weight: bold;
    text-align: center;
}
.filter-group{
    display: flex;
    flex-direction: column;
    flex: 1;
    margin: 1px;
    padding: 2px;
}

.filter-group label{
    margin: 0px 10px;
    align-self: center;
    font-weight: bold;
    font-size: medium;
}

.slide-enter-active {
  transition: transform 1s;
}

.slide-enter {
  transform: translateY(-100%);
}

.slide-leave-active {
  transition: transform 1s;
}

.slide-leave-to {
  transform: translateY(-100%);
}

.custom-slide {
    top: 0 !important;
    transition: ease-out 0.5s;
}

@media (max-width: 850px) {
  #filter-toggle {
    /* justify-content: flex-end; */
    transition: 0.2s;
  }
}

@media (max-width: 534px) {
    #dynamic-section{
        top: -300
    }
}
</style>